import { AxiosError } from 'axios';
import { isString } from 'lodash';
import { Snackbar } from 'src/components/snackbar';

import { isProduction } from './environment';

//global error codes types
export const errorCodes = [400, 404, 403];

export const handleErrors = (
  error: unknown,
  showSnackbar: boolean = true,
  customError: string | undefined = undefined,
) => {
  let msg = '';

  if (error instanceof AxiosError) {
    msg = error.response?.data?.error || error.message;
  } else if (error instanceof Error) {
    msg = error.message;
  } else {
    msg = isString(error) ? error : 'Unknown error';

    error = new Error(msg);
  }

  if (msg) {
    if (showSnackbar) {
      Snackbar.error(customError || msg);
    }

    if (!isProduction()) {
      console.error(msg);
    }
  }

  throw error;
};
